import {
  FC,
  useState,
  useEffect,
  createContext,
  useContext,
  useRef,
  Dispatch,
  SetStateAction,
} from 'react'
import { GetCourseOutput } from '../../../../Adaptor/TUBSIS/controllers/Courses/models/getCourseModels'

import { WithChildren } from '../../../../_metronic/helpers'
import { getCourse, getUserGroupByUserId } from '../../../../Adaptor/TUBSIS'
import { GetUserGroupByUserIdOutput } from '../../../../Adaptor/TUBSIS/controllers/UserGroups/models/getUserGroupModels'
import { useAuth } from '../../auth/core/Auth'

interface ICourseContext {
  course: GetCourseOutput | null
  fillCourseToState: (id: number | undefined) => void
}
const CourseContext = createContext<ICourseContext>({
  course: null,
  fillCourseToState: (id: number | undefined) => { },
})
const useCourseContext = () => {
  return useContext(CourseContext)
}

const CourseProvider: FC<WithChildren> = ({ children }) => {

  const { currentUser, logout } = useAuth()

  const [userGroups, setUserGroups] = useState<GetUserGroupByUserIdOutput[] | null>(null)

  const [course, setCourse] = useState<GetCourseOutput | null>(null)
  const fillCourseToState = (id: number | undefined) => {
    ////debugger

    if (currentUser && currentUser.id !== null) {
      getUserGroupByUserId(currentUser?.id)
        .then((response) => {
          //console.log("çalıştı", JSON.stringify(response.data))
          if (response && response.data !== null) {
            setUserGroups(response.data)

            {/* expert ve officer değil ise */ }
            if (response.data && response.data?.filter(ug => ug.id !== '4' && ug.id !== '5')?.length > 0) {
              getCourse()
                .then((response) => {
                  ////debugger
                  setCourse(response.data)
                })
                .catch((error) => {
                  ////debugger
                  console.log(error)
                })
            } else {
              setCourse(null)
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching user claims:", error);
        });
    }
  }
  return (
    <CourseContext.Provider value={{ course, fillCourseToState }}>{children}</CourseContext.Provider>
  )
}
export { CourseProvider, useCourseContext }
